<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="detail-bg"></div>
    <div class="container">
      <div class="detail-box" v-if="info">
        <div class="title">{{ $t('sweepstake') }}</div>
        <div class="info">
          <div
            class="image"
            :style="{
              backgroundImage:
                'url(' + this.$store.state.imgUrl + info.image + ')'
            }"></div>
          <div class="tit">{{ info.name }}</div>
          <div class="status-component" :class="'status' + info.status">
            {{ info.statusName }}
          </div>
          <div
            class="share"
            v-if="info.status === 1"
            style="position: absolute; top: 0; right: 0"
            @click="handleShare">
            <span>{{ $t('share') }}</span>
          </div>
        </div>
        <div class="des">{{ info.instructions }}</div>
        <template v-if="info.type === 1">
          <div class="title2">
            <span>{{ $t('windfall') }}</span>
          </div>
          <div
            class="score-list disabled"
            v-for="(item, index) in info.score_options"
            :key="index">
            <div class="flexable">
              <div
                class="name"
                :style="{
                  backgroundImage:
                    'url(' + $store.state.imgUrl + item.home_image + ')'
                }">
                {{ item.home_team }}
              </div>
              <div class="vs">VS</div>
              <div
                class="name"
                :style="{
                  backgroundImage:
                    'url(' + $store.state.imgUrl + item.away_image + ')'
                }">
                {{ item.away_team }}
              </div>
            </div>
            <div class="score-box flexable readyonly">
              <div class="box">{{ item.home_score }}</div>
              <div class="m">:</div>
              <div class="box">{{ item.away_score }}</div>
            </div>
          </div>
        </template>
        <template v-if="info.type === 2">
          <div class="title2">
            <span>{{ $t('windfall') }}</span>
          </div>
          <div class="a2">
            <div
              class="score-list type2 disabled"
              v-for="(item, index) in info.top_scorer_options"
              :key="index">
              <div class="flexable">
                <div
                  class="a"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.player_image + ')'
                  }"></div>
                <div class="in">
                  <div class="n">{{ item.player_name }}</div>
                  <div class="d">{{ $t('activitypage.text15') }}</div>
                </div>
                <div class="num">
                  {{ item.player_score }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="info.type === 3">
          <div class="score-list disabled" v-if="info && info.status === 3">
            <div class="group-box">
              <div
                class="flag"
                :style="{
                  backgroundImage:
                    'url(' + this.$store.state.imgUrl + info.championImage + ')'
                }"></div>
              <div class="name">{{ info.championName }}</div>
              <div class="status" :class="info.champion ? 'success' : ''"></div>
            </div>
          </div>

          <div class="a3">
            <mt-navbar
              v-model="selected"
              class="center"
              style="margin-top: 0.2rem">
              <mt-tab-item id="1" clss="up">{{
                $t('activitypage.text3')
              }}</mt-tab-item>
              <mt-tab-item id="2" clss="up">{{
                $t('activitypage.text4')
              }}</mt-tab-item>
            </mt-navbar>
            <div class="des ac">{{ $t('activitypage.text5') }}</div>
            <!-- tab-container -->
            <mt-tab-container v-model="selected">
              <mt-tab-container-item id="1">
                <div class="groups">
                  <div class="bg"></div>
                  <div
                    class="item"
                    v-for="(item, index) in info.options"
                    :key="index"
                    :class="'item' + item.game_id"
                    v-show="
                      ['49', '50', '53', '54', '57', '58', '61', '64'].indexOf(
                        item.game_id
                      ) > -1
                    ">
                    <div class="box home_team">
                      <div
                        class="add"
                        :class="item.home_team_flag ? 'flag' : ''"
                        :style="{
                          backgroundImage:
                            'url(' +
                            $store.state.imgUrl +
                            item.home_team_flag +
                            ')'
                        }"></div>
                    </div>
                    <div class="box away_team" v-if="item.game_id !== '64'">
                      <div
                        class="add"
                        :style="{
                          backgroundImage:
                            'url(' +
                            $store.state.imgUrl +
                            item.away_team_flag +
                            ')'
                        }"></div>
                    </div>
                  </div>
                  <div class="groups-text text16">
                    {{ $t('add.text92') }}
                  </div>
                  <div class="groups-text text8">
                    {{ $t('add.text93') }}
                  </div>
                  <div class="groups-text text4">
                    {{ $t('add.text94') }}
                  </div>
                  <div class="groups-text textf">{{ $t('final') }}</div>
                </div>
              </mt-tab-container-item>
              <mt-tab-container-item id="2">
                <div class="groups reverse">
                  <div class="bg"></div>
                  <div
                    class="item"
                    v-for="(item, index) in info.options"
                    :key="index"
                    :class="'item' + item.game_id"
                    v-show="
                      ['51', '52', '55', '56', '59', '60', '62', '64'].indexOf(
                        item.game_id
                      ) > -1
                    ">
                    <div class="box home_team" v-if="item.game_id !== '64'">
                      <div
                        class="add"
                        :class="item.home_team_flag ? 'flag' : ''"
                        :style="{
                          backgroundImage:
                            'url(' +
                            $store.state.imgUrl +
                            item.home_team_flag +
                            ')'
                        }"></div>
                    </div>
                    <div class="box away_team">
                      <div
                        class="add"
                        :class="item.away_team_flag ? 'flag' : ''"
                        :style="{
                          backgroundImage:
                            'url(' +
                            $store.state.imgUrl +
                            item.away_team_flag +
                            ')'
                        }"></div>
                    </div>
                  </div>
                  <div class="groups-text text16">
                    {{ $t('add.text92') }}
                  </div>
                  <div class="groups-text text8">
                    {{ $t('add.text93') }}
                  </div>
                  <div class="groups-text text4">
                    {{ $t('add.text94') }}
                  </div>
                  <div class="groups-text textf">{{ $t('final') }}</div>
                </div>
              </mt-tab-container-item>
            </mt-tab-container>
            <div class="champion-box disabled">
              <div class="box">
                <div
                  class="img"
                  v-if="info.champion"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + info.championImage + ')'
                  }"></div>
              </div>
            </div>
          </div>
        </template>
        <div class="list5">
          <div
            class="flexable arrow"
            @click="
              () => {
                this.popType = 'list'
                this.popupVisible = true
              }
            ">
            <div class="label">{{ $t('tickets') }}</div>
            <div class="cont">
              <span class="ticket">{{ $t('myticket') }}</span
              ><span class="num">{{ info.my_bet_count }}</span>
            </div>
          </div>
        </div>
        <template v-if="info && info.status === 3">
          <div
            class="greeting-box"
            v-if="info && (info.win_score > 0 || info.lose_token > 0)">
            <div class="txt">{{ $t('congratulations') }}🎉🎉🎉</div>
            <div class="dis">
              <span
                v-if="info.win_score > 0 && info.lose_token <= 0"
                v-htm="
                  $t('activitypage.text91', {
                    num: info.win_score,
                    type: $t('web5token')
                  })
                "></span>
              <span
                v-if="info.win_score <= 0 && info.lose_token > 0"
                v-html="
                  $t('activitypage.text99', {
                    num: info.lose_token,
                    type: $t('krazetoken')
                  })
                "></span>
              <span
                v-if="info.win_score > 0 && info.lose_token > 0"
                v-html="
                  $t('activitypage.text999', {
                    num1: info.win_score,
                    typ1: $t('web5token'),
                    num2: info.lose_token,
                    typ2: $t('krazetoken')
                  })
                "></span>
            </div>
          </div>
          <div
            class="greeting-box"
            v-if="info && info.win_score <= 0 && info.lose_token <= 0">
            <div class="txt pity">{{ $t('activitypage.text21') }}</div>
            <div class="dis">{{ $t('activitypage.text22') }}</div>
          </div>
        </template>
        <div class="list-title4">{{ $t('winners') }}</div>
        <div class="list4">
          <div
            class="flexable"
            v-for="item in winnders"
            :class="item.self ? 'mine' : ''"
            :key="item.rank">
            <div class="label">{{ item.email }}</div>
            <div class="val">{{ $handleNum(item.win_score) }}</div>
          </div>
        </div>
      </div>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <Tickets
        v-if="popType === 'list'"
        :type="info.type"
        :countries="countries"
        :list="ticketList" />
      <SharePop
        :sharePath="sharePath"
        @cancel="
          () => {
            this.popupVisible = false
          }
        "
        v-if="popType === 'share'" />
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import {
  postActivityCountries,
  postActivityInfo,
  postActivityMyjoins,
  postActivityWinlists
} from '@/api/user'
import SharePop from '@/components/SharePop.vue'
import Tickets from '@/components/Tickets.vue'

export default {
  name: 'UserActDetail',
  components: { Tickets, SharePop },
  data() {
    return {
      popupVisible: false,
      selected: '1',
      info: null,
      popType: null,
      ticketList: [],
      winnders: [],
      countries: [],
      sharePath: ''
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== this.$store.state.fromName) {
      this.$store.commit('SET_KEEP_ALIVE', [])
    }
    next()
  },
  methods: {
    setImage(item) {
      let awayTeam = this.countries.find((e) => {
        return e.id === item.away_team
      })
      let homeTeam = this.countries.find((e) => {
        return e.id === item.home_team
      })
      if (awayTeam) {
        item.away_team_flag = awayTeam.image
      }
      if (homeTeam) {
        item.home_team_flag = homeTeam.image
      }
      return item
    },
    init() {
      let params = {
        rec_code: this.$route.query.rec_code
      }
      postActivityInfo(params).then((res) => {
        if (res.data.status === 1) {
          res.data.statusName = this.$t('inprogress')
        } else if (res.data.status === 2) {
          res.data.statusName = this.$t('tobedrawn')
        } else if (res.data.status === 3) {
          res.data.statusName = this.$t('finished')
        }

        if (res.data.type === 3) {
          postActivityCountries().then((res1) => {
            this.countries = res1.data
            if (res.data.champion) {
              let champion = res1.data.find((item) => {
                return item.id === res.data.champion
              })
              res.data.championName = champion.name
              res.data.championImage = champion.image
            }
            res.data.options = res.data.options.map((item) => {
              return this.setImage(item)
            })
            this.info = res.data
          })
        } else {
          this.info = res.data
        }
      })

      postActivityMyjoins(params).then((res) => {
        this.ticketList = res.data
      })
      postActivityWinlists(params).then((res) => {
        this.winnders = res.data
      })
    },
    handleShare() {
      if (!this.$store.state.token) {
        this.$bus.emit('handleLogin')
      } else {
        this.sharePath =
          this.$store.state.userPath +
          '/user/activity?inviteCode=' +
          this.$store.state.user_info.rec_code +
          '&inviteAct=' +
          this.info.rec_code +
          '&rec_code=' +
          this.info.rec_code
        this.popType = 'share'
        this.popupVisible = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/actdetail.vue